module.exports = __webpack_public_path__ + "img/Bob_sfouggar.86f8ffc1.jpg";